import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { set as setNotification } from 'store/notification/actions'
import { fetchAll, remove, update, create } from 'UserApp/store/address/action'
import {
  selectAll,
} from 'UserApp/store/address/selector'
import ManageAddressScreen from 'UserApp/screens/ManageAddress'
import { AddressType } from 'types'

class ManageAddressScreenContainer extends React.PureComponent {
  static propTypes = {
    hasAddress: PropTypes.bool,
    fetchAll: PropTypes.func,
    remove: PropTypes.func,
    update: PropTypes.func,
    create: PropTypes.func,
    match: PropTypes.shape({
      path: PropTypes.string,
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
    addresses: PropTypes.arrayOf(PropTypes.shape(AddressType)),
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
  }

  state = { isLoading: true }

  async componentDidMount() {
    const { fetchAll } = this.props
    try {
      const result = await fetchAll()
    } catch (e) {
      console.error('Failed to fetch addresses:', e)
    }
    this.setState({ isLoading: false })
  }

  handleClose = () => this.props.history.push('/manage-address')

  handleSubmit = async (data) => {
    try {
      const { update, create } = this.props
      if (this.props.addressId) {
        await update(this.props.addressId, data)
      } else {
        await create(data)
      }
    } catch (error) {
      console.error('Failed to submit address:', error)
    }
  }

  handleDelete = async (id) => {
    const { remove, fetchAll } = this.props
    await remove(id)
    await fetchAll()
  }

  handleUpdate = async (id, data) => {
    const { update, fetchAll, setNotification } = this.props
    try {
      await update(id, data)
      await fetchAll()
      setNotification(`Address updated`)
    } catch (error) {
      setNotification(error.message || 'Failed to update address')
    }
  }

  generateProps = () => {
    const { match } = this.props
    const { path, params, url } = match

    return {
      ...this.props,
      ...this.state,
      addressId: params.id,
      isAddingAddress: path === '/manage-address/new',
      isEditingAddress: path === '/manage-address/:id',
      isDeletingAddress: path === '/manage-address/delete/:addressId/:addressName',
      onClose: this.handleClose,
      addresses: this.props.addresses,
      onSubmit: this.handleSubmit,
      onDelete: this.handleDelete,
      onUpdate: this.handleUpdate,
    }
  }

  render() {
    const props = this.generateProps()

    return <ManageAddressScreen {...props} onClose={this.handleClose} onSubmit={this.handleSubmit} />
  }
}

export default connect(
  (state) => ({
    hasAddress: selectAll(state).length > 0,
    addresses: selectAll(state),
  }),
  {
    fetchAll,
    remove,
    update,
    create,
    setNotification,
  },
)(ManageAddressScreenContainer)
